import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");
  const hasRetried = useRef(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/verify-mail/${token}`
        );

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        setStatus("success");
        setMessage(data.message || "Email erfolgreich verifiziert!");
      } catch (error) {
        console.error("Verification failed:", error);

        if (!hasRetried.current) {
          hasRetried.current = true;
          setTimeout(verifyEmail, 1000);
          return;
        }

        setStatus("error");
        setMessage(
          error.message ||
            "Verifizierung fehlgeschlagen. Bitte erneut versuchen."
        );
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setStatus("error");
      setMessage("Ungültiges oder fehlendes Token.");
    }
  }, [token]);
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {status === "loading" && (
          <p style={{ ...styles.text, color: "#555" }}>
            Deine Email wird verifiziert...
          </p>
        )}
        {status === "success" && (
          <>
            <p style={{ ...styles.text, color: "green", fontWeight: "bold" }}>
              {message}
            </p>
            <button
              onClick={() => navigate("/login")}
              style={styles.buttonSuccess}
            >
              Zum Login
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <p style={{ ...styles.text, color: "red", fontWeight: "bold" }}>
              {message}
            </p>
            <button
              onClick={() => navigate("/login")}
              style={styles.buttonError}
            >
              Zurück zum Login
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f3f4f6",
    padding: "20px",
  },
  card: {
    backgroundColor: "#fff",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "30px",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
  },
  text: {
    fontSize: "18px",
    marginBottom: "20px",
    color: "#333",
  },
  buttonSuccess: {
    backgroundColor: "green",
    color: "#fff",
    fontSize: "16px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  buttonError: {
    backgroundColor: "red",
    color: "#fff",
    fontSize: "16px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
};

export default EmailVerification;
